import React from 'react';
import { Shield, Lock, FileText } from 'lucide-react';
import { useScrollReveal } from '@/lib/useScrollReveal';
import clsx from 'clsx';

const trustPillars = [
  {
    icon: Shield,
    title: 'SOC 2 Type II',
    description: 'Annual security audit. Verified by independent auditors.',
  },
  {
    icon: Lock,
    title: 'AES-256 Encryption',
    description: 'All memories encrypted at rest and in transit. BYOK available.',
  },
  {
    icon: FileText,
    title: 'Audit Trail',
    description: 'Every memory operation logged with timestamp and actor.',
  },
];

export const TrustSection: React.FC = () => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section className="py-20 bg-surface-secondary" ref={ref}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={clsx(
            'text-center mb-12 transition-all duration-500',
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          )}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-text-primary mb-4">
            Built for the Enterprise
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto">
            Security and compliance baked into every layer
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {trustPillars.map((pillar, index) => (
            <div
              key={pillar.title}
              className={clsx(
                'bg-white rounded-xl p-8 border border-border transition-all duration-500',
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              )}
              style={{ transitionDelay: `${(index + 1) * 100}ms` }}
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-6">
                <pillar.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-text-primary mb-3">
                {pillar.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;